import React, { useState } from "react";
import '../../styles/controls/Toogle.css';
const ToogleButton = ({isToogled,onChange,
    size = "80px",
    marginTop = '0px',
    marginBottom = '0px',
    marginLeft = '0px',
    marginRight = '0px',
    paddingLeft = '0px',
    paddingRight = '0px',
    unToogledBackgroundColor = "gray",
    toogledBackgroundColor="rgba(155, 30, 30, 0.952)"}) =>{
    return(
        <div className="toogle-container" style={{
            marginTop:marginTop,
            marginBottom:marginBottom,
            marginLeft:marginLeft,
            marginRight:marginRight,
            paddingLeft:paddingLeft,
            paddingRight:paddingRight,
            boxSizing:"border-box"}}>
            <label className="toogle-switch" style={{width:`calc(${size})`,height:`calc(${size} / 2)`}}>
                <input
                    type="checkbox"
                    checked={isToogled}
                    onChange={onChange}
                />
                <span className="slider" style={{backgroundColor:isToogled? toogledBackgroundColor:unToogledBackgroundColor}}></span>
            </label>
        </div>
    );
}
export default ToogleButton;